// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"7bb59d24","72":"277c6fad","115":"6203195c","252":"5bae2337","448":"531063d4","532":"a5d4bd7a","767":"b2a1c867","842":"6f10b420","910":"5cc04467","958":"3cc5b407","969":"1a3e0031"}[chunkId] + ".chunk.css";
};